import { Box } from "@chakra-ui/react";
import styled from "@emotion/styled";

export default styled(Box)`
  pointer-events: ${(props) => (props.preventInteractions ? "none" : "all")};
  opacity: ${(props) => (props.preventInteractions ? 0.4 : 1)};
`;
